import React from 'react'
import { Link } from 'gatsby'
import { scroll_top } from '../lib/window'
import md from 'markdown-it'
import { API_HOST } from '../lib/xhr'
import Navigation from '../components/Navigation'

const mdp = md({
  html: true,
  linkify: true
})

const AboutView = ({ model, menu_state }) => {
  const panel = model ? model.panel : null
  const page = model ? model : { name: '', Body: ''}
  const profiles = model ? model.profile : []

  return (
    <div id="about-view" className="view">
      <header>
        <div className={menu_state}>
          <div className="py-2 bg-darkazul bg-opacity-80 text-white text-xl">
            <Navigation link_cls="hover:text-ice font-medium" />
          </div>
        </div>
        <div className="container pt-20 lg:pt-24 px-4 lg:px-0">
          <h1 className="text-center text-darkazul text-5xl font-light pb-12">{page.name}</h1>
          <div className="flex items-stretch">
            <div className="flex-grow">&nbsp;</div>
            <div className="self-auto">
              {page.photo !== undefined ? <img id="the-team" src={API_HOST + page.photo.url} alt={page.photo.name} /> : null}
            </div>
            <div className="flex-grow">&nbsp;</div>
          </div>
        </div>
      </header>
      <main id="about" className="text-texgray">
        <div className="container px-4 lg:px-0">
          <div className="py-24">
            {page.Body.split("\n").map((rtf, key) => {
              const html = mdp.renderInline(rtf)
              return <p key={key} className="py-2" dangerouslySetInnerHTML={{ __html: html }}></p>
            })}
          </div>
        </div>
        {
          profiles.length ?
          <div style={{ maxWidth: 940 }} className="container px-4 lg:px-0">
            <div className="mb-24 grid justify-items-center grid-cols-1 md:grid-cols-4 lg:grid-cols-4 auto-cols-max">
              {profiles.map((p, key) => {
                return (
                  <div key={key} className="hover:shadow-lg w-full h-full mb-6">
                    <div className="flex items-center justify-center pt-12">
                      <div className="rounded-full h-36 w-36 shadow-md mb-4" style={{ background: `url(${API_HOST}${p.photo.url})`, backgroundPosition: '50% 20%', backgroundSize: 'contain' }}></div>
                    </div>
                    <div className="text-center text-black text-lg">{p.name}</div>
                    <div className="text-center text-texgray">{p.title}</div>
                  </div>
                )
              })}
            </div>
          </div>
          : null
        }
        {
          panel ?
          <div className="text-white bg-azul">
            <div className="container flex flex-wrap px-4 lg:px-0">
              <div className="w-full py-20">
                <div className="py-6 font-light text-center text-3xl">
                  {panel.body.split("\n").map((s, key) => {
                    return <span key={'rtf-' + key}>{s}<br /></span>
                  })}
                </div>
                <div className="flex justify-center">
                  <Link className="btn btn-default" to="/contact" onClick={scroll_top}>Enquire Now</Link>
                </div>
              </div>
            </div>
          </div>
          : null
        }
      </main>
    </div>
  )
}

export default AboutView